import { clientList } from 'src/redux/clientStatus/clientstatus.action'
import axios from '../config/axios'
import { handleResp } from '../config/axios'
import fileDownload from 'js-file-download'
export const getSiteSetting = async (data) => {
  try {
    let respData = await axios({
      method: 'get',
      url: `api/admin/getSiteSetting`,
      params: data,
    })
    return handleResp(respData, 'success')
  } catch (err) {
    return handleResp(err, 'error')
  }
}

export const updateSetting = async (data) => {
  try {
    let respData = await axios({
      method: 'put',
      url: `api/admin/updateSiteSetting`,
      data,
    })
    return handleResp(respData, 'success')
  } catch (err) {
    return handleResp(err, 'error')
  }
}

export const updateSiteDetail = async (data) => {
  try {
    let respData = await axios({
      method: 'put',
      url: `api/admin/updateSiteDetails`,
      data,
    })
    return handleResp(respData, 'success')
  } catch (err) {
    return handleResp(err, 'error')
  }
}

export const updateUsrDash = async (data) => {
  try {
    let respData = await axios({
      method: 'put',
      url: `api/admin/updateUsrDash`,
      data,
    })
    return handleResp(respData, 'success')
  } catch (err) {
    return handleResp(err, 'error')
  }
}

export const getPairDropdown = async (data) => {
  try {
    let respData = await axios({
      method: 'get',
      url: `api/admin/getPairDropdown`,
      data,
    })
    return handleResp(respData, 'success')
  } catch (err) {
    return handleResp(err, 'error')
  }
}
export const updateMailIntegrate = async (data) => {
  try {
    let respData = await axios({
      method: 'post',
      url: `api/admin/updatemailintegrate`,
      data,
    })
    return handleResp(respData, 'success')
  } catch (err) {
    return handleResp(err, 'error')
  }
}
export const getMailIntegrate = async (data) => {
  try {
    let respData = await axios({
      method: 'get',
      url: `api/admin/getemailintegrate`,
      data,
    })
    return handleResp(respData, 'success')
  } catch (err) {
    return handleResp(err, 'error')
  }
}
export const updatesmsConfig = async (data) => {
  try {
    let respData = await axios({
      method: 'post',
      url: `api/admin/updatesmsconfig`,
      data,
    })
    return handleResp(respData, 'success')
  } catch (err) {
    return handleResp(err, 'error')
  }
}

export const downlaodDb = async (data) => {
  try {
    let respData = await axios({
      method: 'post',
      url: `api/admin/downlaodDb`,
      data,
    })

    return fileDownload(respData.data, `DB_BinaryFile-${new Date()}`)
  } catch (err) {
    return handleResp(err, 'error')
  }
}



export const updateHeaderAccess = async (data) => {
  try {
    let respData = await axios({
      method: 'post',
      url: `api/admin/header-access`,
      data,
    })
    return handleResp(respData, 'success')
  } catch (err) {
    return handleResp(err, 'error')
  }
}



export const getAllClientStatus = async (dispatch) => {
  try {
    let respData = await axios({
      method: "get",
      url: `api/admin/getAllClientStatus`,
    });
    clientList(
      {
        list: respData?.data?.result?.data,
      },
      dispatch
    );
    return handleResp(respData, "success");
  } catch (err) {
    return handleResp(err, "error");
  }
};

export const getClientStatus = async (data) => {
  try {
    let respData = await axios({
      method: "get",
      url: `api/admin/Client-Status`,
      params: data,
    });
    return handleResp(respData, "success");
  } catch (err) {
    return handleResp(err, "error");
  }
};

export const clientStatusAdd = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `api/admin/Client-Status`,
      data,
    });
    return handleResp(respData, "success");
  } catch (err) {
    return handleResp(err, "error");
  }
};

export const clientStatusDelete = async (data) => {
  try {
    let respData = await axios({
      method: "delete",
      url: `api/admin/Client-Status`,
      data,
    });
    return handleResp(respData, "success");
  } catch (err) {
    return handleResp(err, "error");
  }
};